/**
 * The position in `stages` of the stage that the stage at `index` reads when
 * it lists no `inputs`: the nearest stage before it that is not a control
 * (`isControl`). Undefined when there is none, because every stage before it
 * is a control or it is the first stage.
 */
export function defaultInputIndex<T>(
  stages: readonly T[],
  index: number,
  isControl: (stage: T) => boolean,
): number | undefined {
  for (let position = index - 1; position >= 0; position -= 1) {
    if (!isControl(stages[position])) {
      return position;
    }
  }
  return undefined;
}
